import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useGetStep, useLastPathSegment } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { useRcsProgressTitle } from 'pages/settings/pages/rcsV2/hooks/useRcsProgressTitle'
import { RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'

export const RcsWizardLayout = observer(() => {
  const { submissionId, closeWizard, navigationStore } = useRcsWizardContext()
  const { allStepsLength, decreaseStep, getSettingsStep, steps, goToStep } = navigationStore
  const lastPathSegment = useLastPathSegment()
  const settingsStep = useGetStep<RcsWizardSteps>(getSettingsStep)
  const progressTitle = useRcsProgressTitle()

  const isValidStep = steps.some((step) => step === lastPathSegment)

  useEffect(() => {
    if (!submissionId) {
      goToStep(RcsWizardSteps.senderDetails)
      return
    }
    if (!isValidStep) goToStep(RcsWizardSteps.countries)
  }, [submissionId, isValidStep, goToStep])

  return (
    <StepsCommonLayout
      title='RCS'
      progressTitle={progressTitle}
      totalSteps={allStepsLength}
      settingsStep={settingsStep}
      closeSetting={closeWizard}
      decreaseStep={decreaseStep}
    />
  )
})
